(function () {
  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  function readCardHeight(swiper, index) {
    const card = swiper.slides?.[index]?.querySelector('.sa-style3-card');
    if (!card) return 0;
    return Math.ceil(card.offsetHeight);
  }

  function clearClipHeight(swiper) {
    const el = swiper?.el;
    if (!el) return;
    el.style.height = '';
    el.style.transition = '';
  }

  function syncActiveHeight(swiper, instant) {
    const el = swiper?.el;
    if (!el) return;

    if (!isMobile()) {
      clearClipHeight(swiper);
      return;
    }

    const height = readCardHeight(swiper, swiper.activeIndex);
    if (height < 1) return;

    if (instant) {
      el.style.transition = 'none';
      el.style.height = `${height}px`;
      el.offsetHeight;
      el.style.transition = '';
      return;
    }

    el.style.height = `${height}px`;
  }

  function createSwiperConfig(root, slideCount) {
    const config = {
      initialSlide: slideCount <= 1 ? 0 : Math.floor(slideCount / 2),
      slidesPerView: slideCount <= 1 ? 1 : 1.15,
      spaceBetween: 12,
      centeredSlides: slideCount > 1,
      loop: false,
      watchOverflow: true,
      observer: true,
      observeParents: false,
      speed: 500,
      grabCursor: slideCount > 1,
      watchSlidesProgress: true,
      slidesPerGroup: 1,
      ...(slideCount > 1
        ? {
            navigation: {
              nextEl: root.querySelector('.sa-reviews-style3-next'),
              prevEl: root.querySelector('.sa-reviews-style3-prev'),
              disabledClass: 'swiper-button-disabled',
            },
          }
        : {}),
      breakpoints: {
        767: {
          slidesPerView:slideCount <= 1 ? 1 : 2.02,
          spaceBetween: 16,
          centeredSlides: slideCount > 1,
        },
        1000: {
          slidesPerView: slideCount <= 1 ? 1 : 1.11,
          spaceBetween: 16,
          centeredSlides: slideCount > 1,
        },
        1200: {
          slidesPerView: slideCount <= 1 ? 1 : 1.2,
          spaceBetween: 16,
          centeredSlides: slideCount > 1,
        },
        1400: {
          slidesPerView: slideCount <= 1 ? 1 : 1.5,
          spaceBetween: 16,
          centeredSlides: slideCount > 1,
        },
        1800: {
          slidesPerView: slideCount <= 1 ? 1 : 2.02,
          spaceBetween: 16,
          centeredSlides: slideCount > 1,
        },
      },
    };

    if (root.dataset.autoplay === 'true') {
      config.autoplay = {
        delay: Number(root.dataset.autoplayDelay) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        stopOnLastSlide: true,
      };
    }

    return config;
  }

  async function addToCart(variantId, btn) {
    if (!variantId || !window.routes?.cart_add_url) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      if (!res.ok) throw new Error('Add to cart failed');

      btn.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch {
      btn.textContent = 'Error';
    } finally {
      window.setTimeout(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 1500);
    }
  }

  function bindAddToCart(root) {
    root.querySelectorAll('[data-sa-reviews-style3-add-to-cart]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', () => addToCart(btn.dataset.variantId, btn));
    });
  }

  function destroySwiper(root) {
    const swiperEl = root.querySelector('[data-sa-reviews-style3-swiper]');
    if (swiperEl?.swiper) {
      clearClipHeight(swiperEl.swiper);
      swiperEl.swiper.destroy(true, true);
      delete swiperEl.dataset.swiperInitialized;
    }
  }

  function initReviewsStyle3(root) {
    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(() => initReviewsStyle3(root), 50);
      return;
    }

    destroySwiper(root);

    const swiperEl = root.querySelector('[data-sa-reviews-style3-swiper]');
    if (!swiperEl) return;

    const slideCount = Number(swiperEl.dataset.slideCount) || swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount < 1) return;

    const swiper = new window.Swiper(swiperEl, createSwiperConfig(root, slideCount));
    swiperEl.dataset.swiperInitialized = 'true';
    bindAddToCart(root);

    const syncNavState = () => {
      swiper.navigation?.update();
    };

    swiper.on('slideChange', () => {
      syncActiveHeight(swiper, false);
      syncNavState();
    });
    swiper.on('slideChangeTransitionEnd', syncNavState);
    swiper.on('resize', () => syncActiveHeight(swiper, true));
    swiper.on('imagesReady', () => syncActiveHeight(swiper, true));
    swiper.on('reachBeginning', syncNavState);
    swiper.on('reachEnd', syncNavState);
    swiper.on('fromEdge', syncNavState);

    swiper.el.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener(
        'load',
        () => {
          if (!swiper.animating) syncActiveHeight(swiper, true);
        },
        { once: true }
      );
    });

    requestAnimationFrame(() => {
      swiper.update();
      syncActiveHeight(swiper, true);
      syncNavState();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sa-reviews-style3]').forEach(initReviewsStyle3);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-sa-reviews-style3]');
    if (root) initReviewsStyle3(root);
  });
})();
